import React, { JSX, useState } from 'react';
import { useFontSizeSettings } from '../hooks/useFontSizeSettings';
import { useSelectTab } from '../hooks/useSelectTab';
import { GlobalContextState } from '../interfaces/GlobalContext.interface';
import { GlobalContext } from './GlobalContext';

interface IProps {
    children: JSX.Element | JSX.Element[];
}

export const GlobalContextProvider = ({ children }: IProps) => {
    const { fontSizeValue, setFontSizeToLocalStorage } = useFontSizeSettings();
    const { selectedTab, setSelectionToLocalStorage } = useSelectTab();
    const [isDark, setIsDark] = useState(false);

    const context: GlobalContextState = {
        fontSize: { get: fontSizeValue, set: setFontSizeToLocalStorage },
        selectedTab: { get: selectedTab, set: setSelectionToLocalStorage },
        isDark: { get: isDark, set: setIsDark },
    };

    return (
        <GlobalContext.Provider value={context}>
            {children}
        </GlobalContext.Provider>
    );
};

export default GlobalContextProvider;
